import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const antiqryAuthGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If already authenticated via cached user or state, allow immediately without delay
  if (authService.userData) {
    return true;
  }

  // Wait for storage initialization to prevent race conditions on page reload
  const isAuth = await authService.waitForAuthReady();
  if (isAuth) {
    return true;
  }

  return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};
